// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3v5aB","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__29MXs","gfeWrapper":"CalendarEvent_gfeWrapper__3rT76"};